/* FortaNexus custom JS
   --------------------------------------------------------------
   The announcement marquee is now rendered server-side in
   sections/header-announcements.liquid (seamless, no JS required).
   Quick-add hiding is handled in CSS (nightforce-custom.css +
   nightforce-overrides.css).

   This file holds the product-page "Naroči zdaj" (Buy Now / COD)
   handler, plus the global checkout firewall and cart drawer. */

/* Safe idle scheduler — requestIdleCallback takes an options object,
   NOT a millisecond delay; passing a number throws and kills the script. */
function nfIdle(fn) {
  if (window.requestIdleCallback) { window.requestIdleCallback(fn, { timeout: 2000 }); }
  else { window.setTimeout(fn, 1); }
}

/* ----------------------------------------------------------
   Quick add to cart on product cards (.fn-quick-add).
   Single-variant products add via AJAX; multi-variant products
   go to the product page (variant choice needed). The header
   cart bubble is refreshed by dispatching Horizon's native
   'cart:update' event — no page reload.
   ---------------------------------------------------------- */
/* NightForce toast v2 — glassy card, animated bolt + drawn checkmark,
   3s progress bar. Single reused node. Exposed globally. */
function fnShowToast(msg, isError) {
  var t = document.getElementById('fn-toast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'fn-toast';
    t.className = 'fn-toast';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    document.body.appendChild(t);
  }
  t.innerHTML =
    '<span class="fn-toast__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none"><path class="fn-toast__bolt" d="M13 2 L6 13 L11 13 L9 22 L18 10 L13 10 Z" fill="#fff"/></svg>' +
    '</span>' +
    '<span class="fn-toast__msg">' + msg + '</span>' +
    '<svg class="fn-toast__check" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M4 12.5 L9.5 18 L20 6.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>' +
    '<span class="fn-toast__bar" aria-hidden="true"></span>';
  t.classList.toggle('fn-toast--error', !!isError);
  t.classList.remove('is-visible');
  void t.offsetWidth; /* restart entrance + bar animations on repeat adds */
  t.classList.add('is-visible');
  if (t._hideTimer) clearTimeout(t._hideTimer);
  t._hideTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 3000);
}
window.fnShowToast = fnShowToast;

/* ----------------------------------------------------------
   NightForce — Update Horizon header cart count bubble.
   Reads /cart.js and updates .cart-bubble + .cart-bubble__text-count
   Called on every add/remove/update.
   ---------------------------------------------------------- */
function fnUpdateCartCount() {
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var n = cart.item_count || 0;
      /* Horizon Liquid refs: .cart-bubble (wrapper), .cart-bubble__text-count (number) */
      var bubble = document.querySelector('.cart-bubble');
      var countEl = document.querySelector('.cart-bubble__text-count, [ref="cartBubbleCount"]');
      var hiddenText = document.querySelector('.visually-hidden + span, #cart-bubble-text .visually-hidden');
      if (bubble) bubble.classList.toggle('visually-hidden', n === 0);
      if (countEl) {
        countEl.textContent = n > 99 ? '99+' : String(n);
        countEl.classList.toggle('hidden', n === 0);
      }
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = String(n); });
      /* Horizon renders no bubble when the cart was empty at page load —
         create our own badge on the header cart link so the count always shows. */
      if (!countEl) {
        var cartLink = document.querySelector('header a[href*="/cart"], .header-actions a[href*="cart"], a[href="/cart"]');
        if (cartLink) {
          var badge = cartLink.querySelector('.fn-count-badge');
          if (!badge && n > 0) {
            badge = document.createElement('span');
            badge.className = 'fn-count-badge';
            if (getComputedStyle(cartLink).position === 'static') cartLink.style.position = 'relative';
            cartLink.appendChild(badge);
          }
          if (badge) {
            badge.textContent = n > 99 ? '99+' : String(n);
            badge.style.display = n === 0 ? 'none' : 'grid';
          }
        }
      }
    })
    .catch(function () {});
}
/* Debounced to prevent rapid successive cart.js requests (429 guard) */
var _cartCountTimer = null;
function fnUpdateCartCountDebounced() {
  clearTimeout(_cartCountTimer);
  _cartCountTimer = setTimeout(fnUpdateCartCount, 300);
}
window.fnUpdateCartCount = fnUpdateCartCountDebounced;

document.addEventListener('cart:update', fnUpdateCartCountDebounced);
document.addEventListener('cart:item-added', fnUpdateCartCountDebounced);


(function initQuickAdd() {
  /* Qty stepper for recommended-product cards (.vx-related__card) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rqty-minus],[data-rqty-plus]');
    if (!btn) return;
    var wrap = btn.closest('.vx-related__qty-wrap, .fn-cart-reco__qty-wrap, .fn-pg__qty-wrap');
    var inp = wrap && wrap.querySelector('.vx-related__qty-input, .fn-cart-reco__qty-input, .fn-pg__qty-input');
    if (!inp) return;
    var val = parseInt(inp.value, 10) || 1;
    var min = parseInt(inp.min, 10) || 1;
    var max = parseInt(inp.max, 10) || 99;
    if (btn.hasAttribute('data-rqty-plus')) { if (val < max) inp.value = val + 1; }
    else { if (val > min) inp.value = val - 1; }
  });

  /* Quick-add on product cards — reads qty from the card's stepper if present */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add], .vx-quick-add');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    /* Multi-variant fallback: navigate to product page */
    if (btn.dataset.multipleVariants === 'true') {
      var url = btn.dataset.productUrl;
      if (url) window.location.href = url;
      return;
    }

    /* Read qty from the nearest stepper (vx-related card), default 1 */
    var card = btn.closest('.vx-related__card, .fn-cart-reco__card, .fn-pg__card, .fn-product-card');
    var qtyInp = card && card.querySelector('.vx-related__qty-input, .fn-cart-reco__qty-input, .fn-pg__qty-input');
    var qty = qtyInp ? (parseInt(qtyInp.value, 10) || 1) : 1;

    /* Toggle logic (Kenan request): a card that is ALREADY in the cart shows
       the red 'Dodano' state — pressing it again REMOVES the product from the
       cart instead of adding more. Quantity tweaks happen via the stepper. */
    if (card && card.classList.contains('fn-in-cart')) {
      btn.disabled = true;
      btn.classList.add('is-loading');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: String(variantId), quantity: 0 })
      })
        .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
        .then(function () {
          if (window.fnShowToast) window.fnShowToast('Odstranjeno iz košarice');
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'fn-quick-remove' } }));
          if (window.fnUpdateCartCount) window.fnUpdateCartCount();
        })
        .catch(function () {
          if (window.fnShowToast) window.fnShowToast('Napaka — poskusite znova', true);
        })
        .finally(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
      return;
    }

    /* Icon buttons (e.g. .fn-pg__atc holds an <svg> + "+") must NEVER have their
       textContent replaced — that wipes the icon and permanently breaks the
       button's style. Detect markup children: if present, keep the inner markup
       intact and convey state via CSS classes only (.is-loading / .is-added).
       Text-only buttons keep the friendly "✓ Dodano!" swap. */
    var hasMarkup = !!btn.querySelector('svg, img, span');
    var origText = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    if (!hasMarkup) btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        if (!hasMarkup) btn.textContent = '✓ Dodano!';
        if (window.fnShowToast) window.fnShowToast('Dodano v košarico ✓');
        if (window.fnCelebrate) window.fnCelebrate();
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'fn-quick-add' } }));
        if (window.fnUpdateCartCount) window.fnUpdateCartCount();
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-added');
          if (!hasMarkup) btn.textContent = origText;
        }, 2000);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.classList.remove('is-added');
        btn.disabled = false;
        if (!hasMarkup) btn.textContent = origText;
        if (window.fnShowToast) window.fnShowToast('Napaka — poskusite znova', true);
      });
  });
})();

/* ----------------------------------------------------------
   Live card-price feature REMOVED.
   The card price now stays static (the normal product price); the
   qty stepper only sets how many units get added to the cart, and
   the correct Vitals volume discount is applied in the cart. The
   former fnCardLivePrice() listener (price = unit × qty) was deleted
   cleanly — no leftover listeners. The +/− stepper handler lives in
   initQuickAdd above and is unaffected.
   ---------------------------------------------------------- */


/* ----------------------------------------------------------
   Measure the two fixed bars (header + announcement) and expose
   their heights as CSS variables so the announcement pins flush
   below the header and page content clears both bars.
   ---------------------------------------------------------- */
function fnSetStickyOffsets() {
  var header = document.querySelector('.header-section');
  var announcement = document.querySelector('.fn-announcement');
  var root = document.documentElement;
  if (header) {
    root.style.setProperty('--fn-header-h', Math.round(header.getBoundingClientRect().height) + 'px');
  }
  if (announcement) {
    root.style.setProperty('--fn-announcement-h', Math.round(announcement.getBoundingClientRect().height) + 'px');
  }
}
var _fnStickyRaf = 0;
function fnSetStickyOffsetsRaf() {
  if (_fnStickyRaf) return;
  _fnStickyRaf = requestAnimationFrame(function () { _fnStickyRaf = 0; fnSetStickyOffsets(); });
}
window.addEventListener('load', fnSetStickyOffsetsRaf, { passive: true });
window.addEventListener('resize', fnSetStickyOffsetsRaf, { passive: true });
document.addEventListener('DOMContentLoaded', fnSetStickyOffsetsRaf);
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(fnSetStickyOffsetsRaf);
}

/* ----------------------------------------------------------
   JS-driven marquee — measure one group, clone enough copies to
   overflow 2x the viewport, animate by the exact pixel width so
   the loop is seam-perfect with no possible gap.
   ---------------------------------------------------------- */
function fnSetupMarquee() {
  document.querySelectorAll('.fn-marquee').forEach(function (marquee) {
    var track = marquee.querySelector('.fn-marquee__track');
    if (!track) return;

    // Reset: keep only the first group, remove previous clones
    var groups = track.querySelectorAll('.fn-marquee__group');
    for (var i = 1; i < groups.length; i++) groups[i].remove();
    track.classList.remove('is-running');
    track.style.removeProperty('--fn-marquee-distance');
    track.style.removeProperty('--fn-marquee-duration');

    var firstGroup = track.querySelector('.fn-marquee__group');
    if (!firstGroup) return;

    requestAnimationFrame(function () {
      var groupWidth = firstGroup.getBoundingClientRect().width;
      if (groupWidth < 10) return;

      var containerWidth = marquee.getBoundingClientRect().width;
      var copiesNeeded = Math.max(2, Math.ceil((containerWidth * 2) / groupWidth) + 1);

      for (var i = 1; i < copiesNeeded; i++) {
        var clone = firstGroup.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      var pixelsPerSecond = 70;
      track.style.setProperty('--fn-marquee-distance', '-' + groupWidth + 'px');
      track.style.setProperty('--fn-marquee-duration', groupWidth / pixelsPerSecond + 's');
      track.classList.add('is-running');
    });
  });
}
window.addEventListener('load', function () {
  nfIdle(fnSetupMarquee);
}, { passive: true });
window.addEventListener('resize', function () {
  clearTimeout(window._fnMarqueeT);
  window._fnMarqueeT = setTimeout(fnSetupMarquee, 200);
}, { passive: true });
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(fnSetupMarquee);
}
/* Mobile: window.load can lag many seconds behind third-party JS — start
   the marquee as soon as the DOM is ready so the bar scrolls immediately. */
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fnSetupMarquee);
else fnSetupMarquee();

/* =============================================================
   v7.0 — Unified checkout: all Buy Now / cart / drawer buttons
   open the Releasit COD popup instead of navigating to /checkout.
   Cart drawer closes first (no overlapping modals).
   ============================================================= */
window.fnOpenCheckout = function (options) {
  options = options || {};

  var triggerReleasit = function (cartData) {
    /* Tracking — fires on every checkout entry point */
    var _numItems = cartData ? cartData.item_count : undefined;
    var _val      = cartData ? cartData.total_price / 100 : undefined;
    var _ic = {};
    if (_numItems !== undefined) _ic.num_items = _numItems;
    if (_val      !== undefined) { _ic.value = _val; _ic.currency = 'EUR'; }
    if (window.fbq) window.fbq('track', 'InitiateCheckout', _ic);
    if (window.gtag) window.gtag('event', 'begin_checkout', _val !== undefined ? { value: _val, currency: 'EUR', items: [] } : {});
    if (window.ttq) window.ttq.track('InitiateCheckout');

    /* fn-cod-bridge opens the real Releasit form (there is no public
       ReleasitCOD API in the app bundle — verified). */
    if (window.fnOpenCodForm) { window.fnOpenCodForm(); return; }

    if (typeof window.ReleasitCOD !== 'undefined' && typeof window.ReleasitCOD.openForm === 'function') {
      window.ReleasitCOD.openForm();
    } else if (typeof window.releasit !== 'undefined' && typeof window.releasit.openForm === 'function') {
      window.releasit.openForm();
    } else {
      /* Try hidden data-releasit-trigger first */
      var hiddenTrigger = document.querySelector('[data-releasit-trigger]');
      if (hiddenTrigger) {
        hiddenTrigger.click();
      } else {
        /* Releasit not yet available — NEVER fall back to /checkout.
           Show a soft error and let the user retry after the app loads. */
        var softErr = document.querySelector('[data-fn-checkout-error]');
        if (softErr) {
          softErr.textContent = 'Sistem plačila se še nalaga. Poskusite znova.';
          softErr.hidden = false;
          setTimeout(function () { softErr.hidden = true; }, 4000);
        }
      }
    }
  };

  /* Close cart drawer if open */
  var d = document.getElementById('fn-cart-drawer');
  if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }

  if (options.addProduct) {
    var btn = options.button;
    var orig = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = 'Obdelava…'; }

    /* With fn-cod-bridge active the add belongs to Vitals; opening on the
       existing cart is correct here (drawer / checkout-firewall entry). */
    if (window.FN_COD_BRIDGE) { window.fnOpenCodForm(); if (options.button) options.button.disabled = false; return; }

    /* Build items array: main product + gift (if qty≥4 on a qualifying page) */
    var _addItems = [{ id: parseInt(options.addProduct.id, 10), quantity: options.addProduct.qty || 1 }];
    if (window.FN_GIFT_VARIANT_ID && (options.addProduct.qty || 1) >= 4 && window.fnIsGiftPage && window.fnIsGiftPage()) {
      _addItems.push({ id: window.FN_GIFT_VARIANT_ID, quantity: 1, properties: { _gift: '1' } });
    }
    var _addBody = _addItems.length > 1 ? { items: _addItems } : _addItems[0];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(_addBody)
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (addedItem) {
        /* AddToCart pixel — fires after confirmed add, with payload */
        var _atcVal = addedItem && addedItem.price ? addedItem.price / 100 : undefined;
        var _atcId  = String(options.addProduct.id);
        var _atcPayload = { content_ids: [_atcId], content_type: 'product', currency: 'EUR' };
        if (_atcVal !== undefined) _atcPayload.value = _atcVal;
        if (window.fbq) window.fbq('track', 'AddToCart', _atcPayload);
        if (window.gtag) window.gtag('event', 'add_to_cart', { currency: 'EUR', value: _atcVal || 0, items: [{ item_id: _atcId }] });
        if (window.ttq) window.ttq.track('AddToCart', _atcPayload);

        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'fn-buy-now' } }));

        /* Fetch cart for InitiateCheckout value, then open Releasit */
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { triggerReleasit(cart); })
          .catch(function () { triggerReleasit(null); });

        if (btn) { btn.disabled = false; btn.textContent = orig; }
      })
      .catch(function (err) {
        var errorEl = document.querySelector('[data-fn-checkout-error]');
        if (errorEl) { errorEl.textContent = 'Prišlo je do napake. Poskusite znova.'; errorEl.hidden = false; }
        if (btn) { btn.disabled = false; btn.textContent = orig; }
      });
  } else {
    /* Direct checkout (no product to add) — fetch cart for value */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { triggerReleasit(cart); })
      .catch(function () { triggerReleasit(null); });
  }
};

/* =============================================================
   fnGiftSync — inject Kamagra Gold "Gratis poklon" as a FREE
   second line into Releasit's Storefront cartLinesAdd mutation
   whenever any of the 11 qualifying products is ordered at qty ≥ 4.

   ADMIN PREREQUISITE (one-time, Shopify Admin):
   ① Go to Products → Kamagra Gold → Variants tab → "Add variant"
   ② Title: "Gratis poklon"  |  Price: €0.00  |  Compare-at: €29.99
   ③ Set "Continue selling when out of stock", hide from Online Store
      channel so customers can't buy it directly.
   ④ Copy the numeric variant ID from the URL (or Variants list).
   ⑤ Replace the 0 below with that ID and redeploy.
   ============================================================= */
(function fnGiftSync() {
  'use strict';

  /* ── ADMIN: paste the numeric ID of the $0 gift variant here ── */
  var GIFT_ID  = 0; /* e.g.  12345678901234 */

  var QUALIFYING = [
    'kamagra-gel','kamagra-sumece-tablete','super-kamagra',
    'sextreme-black-force','kamagra-bomboni','lovegra-viagra-za-zenske',
    'cobra-120mg','vidalista-60','sextreme-red-force-150-mg',
    'kraljevski-med-12x20g','kamagra-gold-4-tablete'
  ];

  /* Expose so fnOpenCheckout (above) and main-product.liquid can read them */
  window.FN_GIFT_VARIANT_ID = GIFT_ID;
  window.fnIsGiftPage = function () {
    var path = location.pathname; /* /products/<handle> */
    return QUALIFYING.some(function (h) { return path.indexOf(h) !== -1; });
  };

  if (!GIFT_ID) {
    /* No-op until admin creates the $0 variant */
    return;
  }

  var GIFT_GID = 'gid://shopify/ProductVariant/' + GIFT_ID;

  /* ── Part A: intercept window.fetch → inject gift line into every
     Shopify Storefront cartLinesAdd Releasit fires at qty ≥ 4 ── */
  var _origFetch = window.fetch;
  window.fetch = function fnGiftFetch(input, init) {
    var url = typeof input === 'string' ? input
            : (input && typeof input.url === 'string') ? input.url : '';

    if (url.indexOf('graphql.json') !== -1 && init && typeof init.body === 'string') {
      var rawBody = init.body;
      if (rawBody.indexOf('cartLinesAdd') !== -1 || rawBody.indexOf('CartLinesAdd') !== -1) {
        try {
          var body   = JSON.parse(rawBody);
          var lines  = (body.variables && body.variables.lines) || [];
          var qty    = lines.reduce(function (s, l) { return s + (parseInt(l.quantity, 10) || 0); }, 0);
          var hasGift = lines.some(function (l) { return l.merchandiseId === GIFT_GID; });

          if (qty >= 4 && !hasGift && window.fnIsGiftPage()) {
            var newLines = lines.concat([{
              merchandiseId: GIFT_GID,
              quantity: 1,
              attributes: [{ key: '_gift', value: '1' }]
            }]);
            init = Object.assign({}, init, {
              body: JSON.stringify(Object.assign({}, body, {
                variables: Object.assign({}, body.variables, { lines: newLines })
              }))
            });
          }
        } catch (_e) { /* leave original untouched on parse error */ }
      }
    }
    return _origFetch.call(this, input, init);
  };

  /* ── Part B: sync gift removal from classic cart when qty drops < 4 ──
     Called by main-product.liquid qty change handler.              ── */
  window.fnSyncGiftInClassicCart = function (qty) {
    if (!window.fnIsGiftPage()) return;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var giftLine = items.find(function (it) { return it.variant_id === GIFT_ID; });
        if (qty >= 4 && !giftLine) {
          /* Auto-add to classic cart (fetch interceptor covers Storefront cart) */
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: GIFT_ID, quantity: 1, properties: { _gift: '1' } })
          }).catch(function () {});
        } else if (qty < 4 && giftLine) {
          /* Remove gift from classic cart */
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: giftLine.key, quantity: 0 })
          }).catch(function () {});
        }
      })
      .catch(function () {});
  };
})();

/* --- [data-fn-buy-now] + [data-fn-checkout-drawer] REMOVED (v8.1) -----------
   Releasit COD now intercepts both triggers natively via standard DOM patterns:
   • PDP "Naroči zdaj": type="submit" name="add" class="product-form__submit"
     inside {% form 'product', product, class: 'fn-pdp__form product-form' %}
   • Cart drawer: form[action="/cart"] > button[name="checkout"].cart__checkout-button
   fnOpenCheckout() is kept as a utility for programmatic edge-case triggers only. */

/* Cart PAGE: native checkout button — no interception needed (COD lives on PDP only). */

/* =============================================================
   v8.0 — GLOBAL CHECKOUT FIREWALL
   Two capture-phase listeners that fire BEFORE any Horizon or
   third-party handler, covering every surface:
     • Horizon's native cart-drawer checkout button
     • Any form that POSTs/GETs to /checkout
     • Dynamic express-checkout buttons injected by apps
   These run in capture phase (3rd arg = true) so they always
   win over bubble-phase listeners attached by Horizon's JS.
   ============================================================= */

/* Layer A — submit event on ANY form targeting /checkout */
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form || form.tagName !== 'FORM') return;
  /* Normalise: strip protocol+host, keep path */
  var action = (form.getAttribute('action') || '').replace(/^https?:\/\/[^/]+/, '').split('?')[0];
  if (action === '/checkout' || action === '/checkouts') {
    e.preventDefault();
    e.stopImmediatePropagation();
    window.fnOpenCheckout();
  }
}, true /* capture */);

/* Layer B REMOVED (v8.1) — Releasit intercepts button[name="checkout"] natively.
   Our capture-phase Layer B was firing BEFORE Releasit could hook in, causing
   the "does nothing" symptom. Layer A (form[action="/checkout"] submit blocker)
   is kept as a hard safety net for any edge-case /checkout form submissions. */


/* =============================================================
   v4.0 — CRO: slide-in cart drawer + upsells, recently viewed, FBT.
   The drawer opens on the native `cart:update` event (dispatched by
   Horizon's add-to-cart AND by fn-quick-add) when the item count rises —
   it never intercepts a form submit, so it cannot double-add.
   ============================================================= */
(function fnCRO() {
  'use strict';

  function fnMoney(cents) {
    // cart.js returns amounts in the store currency's minor units (EUR cents).
    var amount = Number(cents) / 100;
    try {
      return amount.toLocaleString('sl-SI', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      return amount.toFixed(2) + ' €';
    }
  }
  window.fnMoney = window.fnMoney || fnMoney;

  // Safeguard: flag impossibly low prices (e.g. Vitals discount misconfig → 38 Ft).
  // minCents = 5000 Ft. Logs a warning; does not alter the displayed value.
  function validateCartPrice(cents, productTitle) {
    /* Disabled: the old 5 000 Ft floor was forint-era and would wrongly flag
       real EUR prices (e.g. €20 = 2000 cents). EUR cart uses the live value. */
    var minCents = 1;
    if (cents > 0 && cents < minCents) {
      return false;
    }
    return true;
  }
  window.fnValidateCartPrice = window.fnValidateCartPrice || validateCartPrice;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function drawer() { return document.getElementById('fn-cart-drawer'); }
  var lastItemCount = null;

  function openDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
  }

  function renderItems(cart) {
    var el = document.querySelector('[data-cart-drawer-items]');
    if (!el) return;
    if (!cart.items.length) {
      el.innerHTML = '<p class="fn-cart-drawer__empty">Košarica je prazna.</p>';
      return;
    }
    el.innerHTML = cart.items.map(function (item) {
      // Bulletproof: if a discount misconfig drops a line below 5 000 Ft (the
      // cheapest real product is ~12 000 Ft), the price is broken — fall back
      // to the undiscounted original_line_price instead of showing a junk value.
      var lineCents = item.final_line_price;
      if (!validateCartPrice(lineCents, item.product_title)
          && item.original_line_price > lineCents) {
        lineCents = item.original_line_price;
      }
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
      var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
        ? '<div class="fn-cart-drawer__item-meta">' + esc(item.variant_title) + '</div>' : '';
      return '<div class="fn-cart-drawer__item" data-line-key="' + item.key + '">' +
        '<img src="' + img + '" alt="' + esc(item.product_title) + '" width="80" height="80" loading="lazy">' +
        '<div class="fn-cart-drawer__item-info">' +
          '<div class="fn-cart-drawer__item-title">' + esc(item.product_title) + '</div>' +
          variant +
          '<div class="fn-cart-drawer__qty">' +
            '<button type="button" class="fn-cart-drawer__qty-btn" data-qty-dec aria-label="Zmanjšaj količino">&minus;</button>' +
            '<span class="fn-cart-drawer__qty-num">' + item.quantity + '</span>' +
            '<button type="button" class="fn-cart-drawer__qty-btn" data-qty-inc aria-label="Povečaj količino">+</button>' +
            '<button type="button" class="fn-cart-drawer__remove" data-line-remove>Odstrani</button>' +
          '</div>' +
        '</div>' +
        '<div class="fn-cart-drawer__item-price">' +
          // Show ONLY the (safeguarded) line price — no strikethrough, no compare price.
          '<span class="fn-price-final">' + fnMoney(lineCents) + '</span>' +
        '</div>' +
        '</div>';
    }).join('');
  }

  function renderUpsells(cart) {
    var box  = document.querySelector('[data-cart-upsells]');
    var list = document.querySelector('[data-upsell-list]');
    if (!list || !box) return;
    if (!cart.items.length) { box.hidden = true; list.innerHTML = ''; return; }
    var firstId = cart.items[0].product_id;
    fetch('/recommendations/products.json?product_id=' + firstId + '&limit=4&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.product_id] = true; });
        var recs = (data.products || []).filter(function (p) {
          return !inCart[p.id] && p.variants && p.variants[0] && p.variants[0].available;
        }).slice(0, 4);
        if (!recs.length) { box.hidden = true; list.innerHTML = ''; return; }
        /* Compact vertical card: image / name / price+add-btn
           Displayed in a horizontal scroll row (flex-direction:row on parent). */
        list.innerHTML = recs.map(function (p) {
          var v   = p.variants[0];
          var img = p.featured_image
            ? p.featured_image.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_120x120$1$2')
            : '';
          /* Wrap in a plain HTML form (action=/cart/add) so Releasit intercepts
             the submit event and opens the COD popup instead of navigating. */
          return '<form action="/cart/add" method="post" class="fn-cart-drawer__upsell-form">' +
            '<input type="hidden" name="id" value="' + v.id + '">' +
            '<input type="hidden" name="quantity" value="1">' +
            '<div class="fn-cart-drawer__upsell">' +
              '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy" width="84" height="84">' +
              '<div class="fn-cart-drawer__upsell-name">' + esc(p.title) + '</div>' +
              '<div class="fn-cart-drawer__upsell-foot">' +
                '<span class="fn-cart-drawer__upsell-price">' + fnMoney(v.price) + '</span>' +
                '<button type="submit" name="add" class="fn-cart-drawer__upsell-add"' +
                  ' data-upsell-add data-variant="' + v.id + '"' +
                  ' aria-label="Naro\u010di: ' + esc(p.title) + '">+</button>' +
              '</div>' +
            '</div>' +
          '</form>';
        }).join('');
        box.hidden = false;
      })
      .catch(function () { box.hidden = true; list.innerHTML = ''; });
  }


  function refreshDrawer() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderItems(cart);
        renderUpsells(cart);
        var total = document.querySelector('[data-cart-drawer-total]');
        if (total) {
          // Same safeguard on the total: an impossibly low total means a broken
          // discount — show the undiscounted original_total_price instead.
          var totalCents = cart.total_price;
          if (!validateCartPrice(totalCents, 'cart total')
              && cart.original_total_price > totalCents) {
            totalCents = cart.original_total_price;
          }
          total.textContent = fnMoney(totalCents);
        }

        // Savings/discount row intentionally removed — cart shows items + total only.
        return cart;
      });
  }

  document.addEventListener('cart:update', function () {
    if (!drawer()) return;
    refreshDrawer().then(function (cart) {
      if (lastItemCount !== null && cart.item_count > lastItemCount) openDrawer();
      lastItemCount = cart.item_count;
    });
    // Vitals injects its volume-discount CODE into the cart asynchronously, a
    // beat after add/qty-change. Re-read the cart once more so the drawer
    // converges to the Vitals-discounted final_line_price/total_price (keeps
    // the theme drawer in sync with the real Shopify cart, the single source).
    clearTimeout(window._fnDrawerResync);
    window._fnDrawerResync = setTimeout(function () {
      if (drawer()) refreshDrawer();
    }, 800);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-close]')) { closeDrawer(); return; }
    if (e.target.id === 'fn-cart-drawer') { closeDrawer(); return; }

    var qBtn = e.target.closest('[data-qty-dec],[data-qty-inc],[data-line-remove]');
    if (qBtn) {
      var row = e.target.closest('[data-line-key]');
      if (!row) return;
      var key = row.getAttribute('data-line-key');
      var numEl = row.querySelector('.fn-cart-drawer__qty-num');
      var cur = parseInt(numEl.textContent, 10) || 1;
      var change = function (qty) {
        return fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
          .then(function () { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'fn-drawer-qty' } })); })
          .catch(function () { row.style.opacity = ''; });
      };
      if (e.target.closest('[data-line-remove]')) { row.style.opacity = '0.5'; change(0); return; }
      /* Optimistic UI + 280ms debounce so mashing +/- coalesces to the final qty (one request). */
      var next = e.target.closest('[data-qty-inc]') ? cur + 1 : Math.max(1, cur - 1);
      numEl.textContent = next;
      row.style.opacity = '0.6';
      window._fnQtyTimers = window._fnQtyTimers || {};
      clearTimeout(window._fnQtyTimers[key]);
      window._fnQtyTimers[key] = setTimeout(function () { change(next); }, 280);
      return;
    }

    /* [data-upsell-add] clicks are now handled via native form submit intercepted
       by Releasit COD. No AJAX handler needed here. */
    if (e.target.closest('[data-upsell-add]')) return;

    var cartLink = e.target.closest('a[href$="/cart"], a[href="/cart"]');
    /* Skip the link if it's already inside the drawer panel — that's the "View Cart"
       button, which should navigate to /cart, not reopen the drawer. */
    if (cartLink && !e.ctrlKey && !e.metaKey && !e.shiftKey && e.button === 0 && drawer()
        && !cartLink.closest('.fn-cart-drawer__panel')) {
      e.preventDefault();
      refreshDrawer().then(openDrawer);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  if (drawer()) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { lastItemCount = cart.item_count; refreshDrawer(); })
      .catch(function () {});
  }

  /* ---------- recently viewed ---------- */
  var RV_KEY = 'fn_recent_products';
  var RV_MAX = 8;
  (function recordCurrent() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    try {
      var handle = m[1];
      var arr = JSON.parse(localStorage.getItem(RV_KEY) || '[]').filter(function (h) { return h !== handle; });
      arr.unshift(handle);
      localStorage.setItem(RV_KEY, JSON.stringify(arr.slice(0, RV_MAX)));
    } catch (e) {}
  })();

  function renderRecentlyViewed() {
    var containers = document.querySelectorAll('[data-recently-viewed]');
    if (!containers.length) return;
    var arr;
    try { arr = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { arr = []; }
    var currentHandle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    /* Guard: only real, non-empty handles — never request /products/none or /products/.js */
    arr = arr.filter(function (h) {
      return h && typeof h === 'string' && h !== 'none' && h !== currentHandle;
    }).slice(0, 4);
    if (!arr.length) { containers.forEach(function (c) { c.hidden = true; }); return; }
    Promise.all(arr.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var valid = products.filter(Boolean);
      if (!valid.length) { containers.forEach(function (c) { c.hidden = true; }); return; }
      var html = '<h3 class="fn-recent__title">Nedavno pregledano</h3><div class="fn-recent__list">' +
        valid.map(function (p) {
          return '<a href="' + p.url + '" class="fn-recent__item">' +
            '<img src="' + (p.featured_image || '') + '" alt="' + esc(p.title) + '" width="120" height="120" loading="lazy">' +
            '<p>' + esc(p.title) + '</p><span>' + fnMoney(p.price) + '</span></a>';
        }).join('') + '</div>';
      containers.forEach(function (c) { c.hidden = false; c.innerHTML = html; });
    });
  }

  /* ---------- frequently bought together ---------- */
  function initFBT() {
    var fbt = document.querySelector('[data-fbt]');
    if (!fbt) return;
    var mainId = fbt.getAttribute('data-product-id');
    var mainPrice = parseInt(fbt.getAttribute('data-product-price'), 10) || 0;
    var mainVariant = fbt.getAttribute('data-product-variant');
    var listEl = fbt.querySelector('[data-fbt-list]');
    if (!mainId || !listEl) return;

    function updateFbtTotal() {
      var total = mainPrice;
      fbt.querySelectorAll('[data-fbt-item]').forEach(function (it) {
        var cb = it.querySelector('input[type="checkbox"]');
        if (cb && cb.checked) total += parseInt(it.getAttribute('data-price'), 10) || 0;
      });
      var t = fbt.querySelector('[data-fbt-total]');
      if (t) t.textContent = fnMoney(total);
    }

    fetch('/recommendations/products.json?product_id=' + mainId + '&limit=4&intent=complementary')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var recs = (data.products || []).filter(function (p) {
          return p.variants && p.variants[0] && p.variants[0].available && String(p.id) !== String(mainId);
        }).slice(0, 2);
        if (!recs.length) { fbt.hidden = true; return; }
        recs.forEach(function (p) {
          var v = p.variants[0];
          var plus = document.createElement('span');
          plus.className = 'fn-fbt__plus'; plus.textContent = '+';
          var item = document.createElement('div');
          item.className = 'fn-fbt__item';
          item.setAttribute('data-fbt-item', '');
          item.setAttribute('data-variant', v.id);
          item.setAttribute('data-price', v.price);
          item.innerHTML = '<img src="' + (p.featured_image || '') + '" alt="' + esc(p.title) + '" width="80" height="80" loading="lazy">' +
            '<p>' + esc(p.title) + '</p><p class="fn-fbt__price">' + fnMoney(v.price) + '</p>' +
            '<label><input type="checkbox" checked> Da, želim</label>';
          listEl.appendChild(plus);
          listEl.appendChild(item);
        });
        fbt.hidden = false;
        updateFbtTotal();
      })
      .catch(function () { fbt.hidden = true; });

    fbt.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"]')) updateFbtTotal();
    });
    var addBtn = fbt.querySelector('[data-fbt-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        if (mainVariant) items.push({ id: parseInt(mainVariant, 10), quantity: 1 });
        fbt.querySelectorAll('[data-fbt-item]').forEach(function (it) {
          var cb = it.querySelector('input[type="checkbox"]');
          if (cb && cb.checked) items.push({ id: parseInt(it.getAttribute('data-variant'), 10), quantity: 1 });
        });
        if (!items.length) return;
        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'fn-fbt' } }));
        }).catch(function () {}).then(function () { addBtn.disabled = false; });
      });
    }
  }

  function init() { renderRecentlyViewed(); initFBT(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



/* v7: free shipping is universal — no threshold bar needed. Static badge in HTML. */

/* ── FortaNexus mobile menu v2 — custom aside, replaces the native drawer ── */
(function () {
  var menu = document.getElementById('fn-mobile-menu');
  var backdrop = document.getElementById('fn-menu-backdrop');
  if (!menu || !backdrop) return;

  function openMenu() {
    menu.classList.remove('is-closed');
    backdrop.classList.remove('is-hidden');
    menu.setAttribute('aria-hidden', 'false');
    menu.removeAttribute('inert');
    backdrop.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(function () { var f = menu.querySelector('a'); if (f) f.focus(); }, 60);
  }
  function closeMenu() {
    menu.classList.add('is-closed');
    backdrop.classList.add('is-hidden');
    menu.setAttribute('aria-hidden', 'true');
    menu.setAttribute('inert', '');
    document.body.style.overflow = '';
    setTimeout(function () { backdrop.hidden = true; }, 220);
  }

  /* Hamburger = Horizon's native <summary class="header__icon--menu"> inside a
     <details>. Intercept the click: preventDefault stops the native drawer toggle,
     then open our aside (the native .menu-drawer is also hidden via CSS). */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.header__icon--menu, [data-fn-menu-open], [aria-controls="fn-mobile-menu"]')) {
      e.preventDefault();
      openMenu();
      return;
    }
    if (e.target.closest('[data-fn-menu-close]')) closeMenu();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !menu.classList.contains('is-closed')) closeMenu();
  });

  /* Tap a nav link → close after navigation fires */
  menu.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () { setTimeout(closeMenu, 50); });
  });

  /* Swipe-left (>=60px, mostly horizontal) closes */
  var sx = 0, sy = 0;
  menu.addEventListener('touchstart', function (e) {
    sx = e.changedTouches[0].clientX; sy = e.changedTouches[0].clientY;
  }, { passive: true });
  menu.addEventListener('touchend', function (e) {
    var dx = sx - e.changedTouches[0].clientX;
    var dy = Math.abs(sy - e.changedTouches[0].clientY);
    if (dx > 60 && dy < 50) closeMenu();
  }, { passive: true });
})();


/* =============================================================
   Cart page — Vitals total reconciliation.
   Vitals applies its volume-discount CODE via JS *after* each cart
   change (verified live: no Shopify automatic discount exists, only a
   Vitals-managed code). So Horizon's native server re-render on +/-
   can briefly show a stale total before Vitals re-applies the correct
   tier. We debounce on `cart:update`, read the real /cart.js once
   Vitals has settled, and reload so the server re-renders the final
   discounted line prices + total. A sessionStorage signature guard
   stops Vitals' on-load re-application from causing a reload loop:
   once we've reloaded into a given (item_count:total_price) state, an
   identical state never reloads again.
   ============================================================= */
(function fnCartVitalsReconcile() {
  if (!/^\/cart(\/|\?|$)/.test(window.location.pathname)) return;
  var KEY = 'fn_cart_sig';
  var timer = null;

  function sigOf(cart) { return cart.item_count + ':' + cart.total_price; }

  /* Seed the guard with the state the page was rendered from (only if not
     already set this session) so an unchanged cart never triggers a reload. */
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (sessionStorage.getItem(KEY) === null) sessionStorage.setItem(KEY, sigOf(cart));
    })
    .catch(function () {});

  function reconcile() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sig = sigOf(cart);
        if (sessionStorage.getItem(KEY) === sig) return; /* already handled this state */
        sessionStorage.setItem(KEY, sig);

        /* Fast path: if Horizon's native re-render already shows the correct
           total (matches the real Vitals-discounted /cart.js total within the
           ±2 Ft rounding Vitals allows), do NOT reload — deletes and simple
           qty changes stay instant. Only reload when the displayed total is
           stale because Vitals applied its discount code after the render. */
        var serverFt = Math.round(Number(cart.total_price) / 100);
        var el = document.querySelector('.cart__total-value');
        var shownFt = el ? parseInt((el.textContent || '').replace(/[^\d]/g, ''), 10) : NaN;
        if (!isNaN(shownFt) && Math.abs(shownFt - serverFt) <= 2) return;

        window.location.reload();
      })
      .catch(function () {});
  }

  document.addEventListener('cart:update', function () {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 1200); /* let Vitals re-apply the tier first */
  });
})();



/* ----------------------------------------------------------
   Swipeable / draggable testimonials marqueemarquee (TASK 5).
   Keeps continuous autoplay + seamless infinite loop, no arrows/dots.
   Touch-swipe (mobile) + click-drag (desktop). Pauses while dragging or
   hovering; resumes after. Respects prefers-reduced-motion (CSS static
   fallback). Applies to every [data-testimonials-marquee] (home + PDP).
   ---------------------------------------------------------- */
(function initTestimonialsDrag() {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var marquees = document.querySelectorAll('[data-testimonials-marquee]');
  if (!marquees.length) return;

  marquees.forEach(function (marquee) {
    var track = marquee.querySelector('.fn-testimonials-track');
    var group = marquee.querySelector('.fn-testimonials-group');
    if (!track || !group) return;

    var groupWidth = 0;
    var pos = 0;
    var speed = 0;        // px per ms
    var paused = false;   // hover
    var dragging = false;
    var startX = 0;
    var startPos = 0;
    var moved = false;
    var lastTs = null;

    function measure() {
      /* group width incl. its padding-right gap (16px) so the seam stays even */
      groupWidth = group.getBoundingClientRect().width + 16;
      speed = groupWidth > 0 ? groupWidth / 48000 : 0; /* ~48s per loop, matches old CSS */
    }
    function wrap() {
      if (groupWidth <= 0) return;
      while (pos <= -groupWidth) pos += groupWidth;
      while (pos > 0) pos -= groupWidth;
    }
    function render() { track.style.transform = 'translate3d(' + pos + 'px,0,0)'; }

    /* rAF runs ONLY while the marquee is on-screen and the tab is visible —
       a perpetual loop here was the single biggest CPU line in Lighthouse. */
    var running = false;
    var onScreen = false;
    function tick(ts) {
      if (!running) return;
      if (lastTs == null) lastTs = ts;
      var dt = ts - lastTs;
      lastTs = ts;
      if (!paused && !dragging) { pos -= speed * dt; wrap(); render(); }
      requestAnimationFrame(tick);
    }
    function start() {
      if (running) return;
      running = true;
      lastTs = null;
      requestAnimationFrame(tick);
    }
    function stop() { running = false; }

    marquee.classList.add('is-js-driven'); /* disables CSS animation */
    measure();
    render();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          onScreen = en.isIntersecting;
          if (onScreen && !document.hidden) { start(); } else { stop(); }
        });
      }, { rootMargin: '80px' }).observe(marquee);
    } else {
      onScreen = true;
      start();
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else if (onScreen) { start(); }
    });
    window.addEventListener('resize', measure, { passive: true });

    marquee.addEventListener('mouseenter', function () { if (!dragging) paused = true; });
    marquee.addEventListener('mouseleave', function () { if (!dragging) paused = false; });

    marquee.addEventListener('pointerdown', function (e) {
      dragging = true; moved = false; startX = e.clientX; startPos = pos;
      marquee.classList.add('is-dragging');
      try { marquee.setPointerCapture(e.pointerId); } catch (err) {}
    });
    marquee.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      pos = startPos + dx; wrap(); render();
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false; paused = false; lastTs = null;
      marquee.classList.remove('is-dragging');
    }
    marquee.addEventListener('pointerup', endDrag);
    marquee.addEventListener('pointercancel', endDrag);
    /* swallow the click that ends a drag so nothing inside navigates accidentally */
    marquee.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });
})();

/* Cart-level gift progress + auto-add REMOVED — the free gift is owned by
   Vitals (volume pricing) per product now. No cart progress bar, no auto-add. */



// ─────────────────────────────────────────────────────────────────────────────

/* Releasit PDP wiring is handled inside fnPlaceReleasitBelowAtc above —
   direct binding on each button element, no delegation needed. */

/* ── Product description images: fix unsized-images audit + lazy-load ─────
   Adds width/height from natural dimensions (prevents CLS) and ensures
   images below the fold use lazy loading (frees bandwidth for LCP image). */
(function fixDescriptionImages() {
  function process() {
    var imgs = document.querySelectorAll('.fn-pdp__description img, .rte img');
    imgs.forEach(function(img) {
      /* Lazy-load all description images — they're always below the product
         image/ATC area so never compete with the LCP element */
      if (!img.hasAttribute('loading')) img.setAttribute('loading', 'lazy');
      /* Decoding async to keep main thread free */
      if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
      /* Set dimensions if natural size is known (image already loaded) */
      function setDims() {
        if (img.naturalWidth && !img.getAttribute('width'))  img.setAttribute('width',  img.naturalWidth);
        if (img.naturalHeight && !img.getAttribute('height')) img.setAttribute('height', img.naturalHeight);
      }
      if (img.complete) setDims();
      else img.addEventListener('load', setDims, { once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', process, { once: true });
  else process();
  document.addEventListener('shopify:section:load', process);
})();


/* ============================================================================
   STICKY HEADER (fix) — the customized theme left the header bar position:static
   (the old v3.3 CSS targeted .header-section / .fn-announcement classes that
   don't match the real elements, so nothing pinned). position:sticky is broken
   here by the body/html overflow scroll-container context. position:fixed is
   immune to that and verified to pin correctly.

   We pin the theme announcement bar (top) and the header group (below it) as
   fixed, and offset <body> by their combined height (measured, so it adapts to
   mobile/desktop and to the announcement being present or not) → header always
   visible on scroll, no content hidden, no CLS. The Vitals widget is NOT touched.
   ========================================================================== */
(function fnStickyHeader() {
  function fix(node, top, z) {
    if (!node) return;
    node.style.setProperty('position', 'fixed', 'important');
    node.style.setProperty('top', top + 'px', 'important');
    node.style.setProperty('left', '0', 'important');
    node.style.setProperty('right', '0', 'important');
    node.style.setProperty('width', '100%', 'important');
    node.style.setProperty('z-index', String(z), 'important');
  }
  function pin() {
    var hdrGroup = document.querySelector('.shopify-section-group-header-group');
    if (!hdrGroup) return;
    var annInner = document.querySelector('.fn-announcement, .announcement-bar');
    var annSec = annInner ? (annInner.closest('.shopify-section') || annInner) : null;
    /* don't fix the announcement if it's empty/hidden */
    var annH = 0;
    if (annSec && annSec.offsetHeight > 0) {
      fix(annSec, 0, 1001);
      annH = annSec.offsetHeight;
    }
    fix(hdrGroup, annH, 1000);
    /* homepage: hero is full-viewport and slides UNDER the transparent header,
       so no space is reserved; other pages keep the offset */
    if (document.body.classList.contains('template-index')) {
      document.body.style.setProperty('padding-top', '0px', 'important');
    } else {
      document.body.style.setProperty('padding-top', (annH + hdrGroup.offsetHeight + 14) + 'px', 'important');
    }
  }
  if (document.readyState !== 'loading') pin();
  else document.addEventListener('DOMContentLoaded', pin);
  window.addEventListener('load', pin);
  window.addEventListener('resize', function () { clearTimeout(window.__fnPinT); window.__fnPinT = setTimeout(pin, 150); });
  [200, 600, 1400].forEach(function (t) { setTimeout(pin, t); });
})();



/* ==================================================================
   NightForce — fn-pg card cart-state sync (Kenan v1)
   After a product is added, its card enters .fn-in-cart: the ATC
   button turns brand-crimson and reads "✓ Dodano", the qty stepper
   mirrors the CART quantity, and −/+ change the cart directly
   (− down to zero removes the line and the card resets).
   Runs before the local stepper handler via capture phase.
   ================================================================== */
(function nfPgCartState() {
  var busy = false;

  function allCards() {
    return document.querySelectorAll('.fn-pg__card [data-quick-add][data-variant-id], .fn-product-card [data-quick-add][data-variant-id]');
  }

  function applyCart(cart) {
    var byVariant = {};
    (cart.items || []).forEach(function (it) { byVariant[it.variant_id] = (byVariant[it.variant_id] || 0) + it.quantity; });
    allCards().forEach(function (btn) {
      var card = btn.closest('.fn-pg__card, .fn-product-card');
      var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
      var qty = byVariant[vid] || 0;
      var inp = card.querySelector('.fn-pg__qty-input');
      if (qty > 0) {
        card.classList.add('fn-in-cart');
        if (inp) inp.value = qty;
      } else {
        if (card.classList.contains('fn-in-cart') && inp) inp.value = 1;
        card.classList.remove('fn-in-cart');
      }
    });
  }

  function sync() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(applyCart)
      .catch(function () {});
  }

  function changeCartQty(vid, qty, card) {
    if (busy) return;
    busy = true;
    card.classList.add('fn-cart-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(vid), quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
      .then(function (cart) {
        applyCart(cart);
        if (qty === 0 && window.fnShowToast) window.fnShowToast('Odstranjeno iz košarice');
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'fn-pg-stepper' } }));
        if (window.fnUpdateCartCount) window.fnUpdateCartCount();
      })
      .catch(function () { sync(); })
      .finally(function () { busy = false; card.classList.remove('fn-cart-busy'); });
  }

  /* capture phase → runs before the local stepper handler */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rqty-minus],[data-rqty-plus]');
    if (!btn) return;
    var card = btn.closest('.fn-pg__card, .fn-product-card');
    if (!card || !card.classList.contains('fn-in-cart')) return; /* not in cart → local stepper behaviour */
    e.stopPropagation();
    e.preventDefault();
    var atc = card.querySelector('[data-quick-add][data-variant-id]');
    var inp = card.querySelector('.fn-pg__qty-input');
    if (!atc || !inp) return;
    var vid = parseInt(atc.getAttribute('data-variant-id'), 10);
    var cur = parseInt(inp.value, 10) || 1;
    var next = btn.hasAttribute('data-rqty-plus') ? Math.min(cur + 1, 10) : cur - 1; /* minus at 1 → 0 → removes */
    if (next === cur) return;
    changeCartQty(vid, next, card);
  }, true);

  document.addEventListener('cart:update', function () { sync(); });
  (function () {
    function idle() { nfIdle(sync); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', idle); } else { idle(); }
  })();
})();
/* initial header-badge sync — deferred to idle so it never competes with first paint */
(function () {
  function go() { window.fnUpdateCartCount && window.fnUpdateCartCount(); }
  function idle() { nfIdle(go); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', idle); } else { idle(); }
})();

/* ==================================================================
   NightForce — full-screen add-to-cart celebration (Kenan request):
   floating hearts across the whole viewport + a big happy face that
   pops in the middle. ~2.8s, non-blocking, skipped for reduced-motion.
   ================================================================== */
window.fnCelebrate = function () {
  try {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var old = document.querySelector('.fn-celebrate');
    if (old) old.remove();
    var o = document.createElement('div');
    o.className = 'fn-celebrate';
    o.setAttribute('aria-hidden', 'true');
    var mark = document.createElement('div');
    mark.className = 'fn-celebrate__mark';
    mark.innerHTML =
      "<svg viewBox='0 0 120 120' fill='none' aria-hidden='true'>" +
        "<defs><linearGradient id='nfCeleG' x1='0' y1='0' x2='1' y2='1'>" +
          "<stop offset='0' stop-color='#FF4A5C'/><stop offset='0.16' stop-color='#C41436'/>" +
          "<stop offset='0.52' stop-color='#1E2F7A'/><stop offset='1' stop-color='#16255E'/>" +
        "</linearGradient></defs>" +
        "<rect x='6' y='6' width='108' height='108' rx='24' fill='url(#nfCeleG)'/>" +
        "<path d='M71 22 L40 68 L56 68 L48 98 L80 52 L64 52 Z' fill='#fff'/>" +
        "<circle class='fn-celebrate__ring' cx='60' cy='60' r='56' stroke='#fff' stroke-width='2.5' fill='none' opacity='0.7'/>" +
      "</svg>";
    o.appendChild(mark);
    var EMO = ['❤️', '⚡', '✨'];
    for (var i = 0; i < 26; i++) {
      var s = document.createElement('span');
      s.className = 'fn-celebrate__p';
      s.textContent = EMO[i % EMO.length];
      s.style.left = (2 + Math.random() * 96) + 'vw';
      s.style.fontSize = (18 + Math.random() * 28) + 'px';
      s.style.animationDelay = (Math.random() * 0.25) + 's';
      s.style.animationDuration = (0.7 + Math.random() * 0.5) + 's';
      o.appendChild(s);
    }
    document.body.appendChild(o);
    setTimeout(function () { o.remove(); }, 1500);
  } catch (e) {}
};

/* ==================================================================
   NightForce — hover mini-cart on the header cart icon (desktop).
   Fetches /cart.js on open, lists items with images/qty/price,
   subtotal + view-cart / checkout actions. Refreshes on cart:update.
   ================================================================== */
(function nfMiniCart() {
  if (window.__nfMiniCart) return;
  window.__nfMiniCart = 1;
  var panel = null, hideTimer = null, wrap = null;

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function render(cart) {
    if (!panel) return;
    var html = '<div class="fn-minicart__head">Vaša košarica' +
      (cart.item_count ? ' <span class="fn-minicart__count">' + cart.item_count + '</span>' : '') + '</div>';
    if (!cart.items || cart.items.length === 0) {
      html += '<div class="fn-minicart__empty">⚡ Košarica je prazna.<br>Napolnite jo z energijo!</div>';
    } else {
      html += '<div class="fn-minicart__items">';
      cart.items.forEach(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '';
        html += '<div class="fn-minicart__item">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy" width="54" height="54">' : '') +
          '<div class="fn-minicart__item-info">' +
            '<span class="fn-minicart__item-title">' + it.product_title + '</span>' +
            '<span class="fn-minicart__item-meta">' + it.quantity + ' × ' + money(it.price) + '</span>' +
          '</div>' +
          '<span class="fn-minicart__item-total">' + money(it.final_line_price) + '</span>' +
          '<button type="button" class="fn-minicart__remove" data-mc-remove="' + it.key + '" aria-label="Odstrani izdelek">' +
            '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
          '</button>' +
        '</div>';
      });
      html += '</div>';
      html += '<div class="fn-minicart__subtotal"><span>Skupaj</span><strong>' + money(cart.items_subtotal_price) + '</strong></div>';
      html += '<div class="fn-minicart__actions">' +
        '<a href="/cart" class="fn-minicart__btn fn-minicart__btn--ghost">Poglej košarico</a>' +
        '<a href="/checkout" class="fn-minicart__btn fn-minicart__btn--main">Na blagajno</a>' +
      '</div>';
    }
    panel.innerHTML = html;
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  var cartLink = null;

  function position() {
    if (!panel || !cartLink) return;
    var r = cartLink.getBoundingClientRect();
    panel.style.top = (r.bottom + 6) + 'px';
    panel.style.right = Math.max(8, window.innerWidth - r.right - 10) + 'px';
  }

  function open() {
    clearTimeout(hideTimer);
    if (!panel) return;
    var wasOpen = panel.classList.contains('is-open');
    position();
    if (!wasOpen) refresh();
    panel.classList.add('is-open');
  }
  function scheduleClose() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { panel && panel.classList.remove('is-open'); }, 420);
  }
  function closeNow() {
    clearTimeout(hideTimer);
    panel && panel.classList.remove('is-open');
  }

  function init() {
    /* re-entrant: if the viewport is narrow now, retry when it widens */
    var mq = window.matchMedia('(min-width: 990px)');
    if (!mq.matches) {
      if (!init._sub) {
        init._sub = 1;
        if (mq.addEventListener) mq.addEventListener('change', function (e) { if (e.matches) init(); });
      }
      return;
    }
    if (panel) return;
    cartLink = document.querySelector('header a[href*="/cart"], .header-actions a[href*="cart"], a[href="/cart"]');
    if (!cartLink) return;
    panel = document.createElement('div');
    panel.className = 'fn-minicart';
    panel.setAttribute('aria-live', 'polite');
    document.body.appendChild(panel); /* fixed to body — immune to header overflow/sticky quirks */
    cartLink.addEventListener('mouseenter', open);
    cartLink.addEventListener('mouseleave', scheduleClose);
    panel.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    panel.addEventListener('mouseleave', scheduleClose);
    panel.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-mc-remove]');
      if (!rm) return;
      e.preventDefault();
      rm.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: rm.getAttribute('data-mc-remove'), quantity: 0 })
      })
        .then(function (r) { if (!r.ok) throw new Error('rm'); return r.json(); })
        .then(function (cart) {
          render(cart);
          if (window.fnShowToast) window.fnShowToast('Odstranjeno iz košarice');
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'fn-minicart' } }));
          if (window.fnUpdateCartCount) window.fnUpdateCartCount();
        })
        .catch(function () { rm.disabled = false; });
    });
    window.addEventListener('scroll', closeNow, { passive: true });
    window.addEventListener('resize', closeNow, { passive: true });
    document.addEventListener('cart:update', function () {
      if (panel && panel.classList.contains('is-open')) refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();


/* homepage transparent header: solidify after scrolling past the top */
(function nfHeroHeader() {
  if (!document.body.classList.contains('template-index')) return;
  function onScroll() {
    document.body.classList.toggle('is-scrolled', window.scrollY > 60);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* /policies/* pages: the policy texts were authored with template
   placeholders that Shopify never renders — scrub them at view time.
   (Real fix lives in Admin > Settings > Policies; this covers until then.) */
(function nfPolicyScrub() {
  if (window.location.pathname.indexOf('/policies/') === -1) return;
  /* single contact page (Kenan): the old policy contact page defers to /pages/contact */
  if (window.location.pathname.indexOf('/policies/contact-information') !== -1) {
    window.location.replace('/pages/contact');
    return;
  }
  function scrub() {
    var root = document.querySelector('.shopify-policy__body, .shopify-policy__container');
    if (!root) return;
    /* hero icon per policy */
    var title = document.querySelector('.shopify-policy__title');
    if (title && !title.querySelector('.nf-policy-icon')) {
      var icons = {
        'shipping-policy': '🚚',
        'refund-policy': '↩️',
        'privacy-policy': '🛡️',
        'terms-of-service': '📜',
        'contact-information': '💬',
        'legal-notice': '⚖️',
        'subscription-policy': '🔁'
      };
      var slug = window.location.pathname.split('/').pop();
      var chip = document.createElement('div');
      chip.className = 'nf-policy-icon';
      chip.textContent = icons[slug] || '⚡';
      title.insertBefore(chip, title.firstChild);
    }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.nodeValue;
      if (t.indexOf('{{') === -1 && t.indexOf('{%') === -1 && t.indexOf('potenciumhr') === -1 && t.indexOf('385') === -1 && t.indexOf('delovnih dni') === -1) continue;
      t = t.replace(/\{\{\s*shop_name\s*\}\}/g, 'Night Force');
      t = t.replace(/\{\{\s*last_updated\s*\}\}/g, '15. avgust 2026');
      t = t.replace(/\{\{\s*[a-z_]+\s*\}\}/g, '');
      /* raw Liquid logic tags pasted into the admin policy text render literally */
      t = t.replace(/\{%[^%{}]*%\}/g, '');
      /* contact details: brand email in, phone numbers out (Kenan) */
      t = t.replace(/potenciumhr@hotmail\.com/gi, 'support@vigorxs.com');
      t = t.replace(/\+?\s?385[\s\d\/()-]{7,}/g, '');
      /* delivery promise is 48h site-wide (Kenan) */
      t = t.replace(/2[\u2013-]5 delovnih dni/g, 'do 48 ur');
      node.nodeValue = t;
    }
    /* after stripping: drop label rows that lost their value ('E-pošta:' with
       nothing after it), whether they are their own <p>/<li> or <br>-separated
       rows inside one <p>; also mend dangling 'kontaktirajte na .' endings */
    var LABEL_ONLY = /^(E-po\u0161ta|E-mail|Telefon|Naslov|Delovni \u010das)\s*:?\s*$/i;
    root.querySelectorAll('p, li').forEach(function (el) {
      if (el.querySelector('img, table, ul, ol')) return;
      var rows = el.innerHTML.split(/<br\s*\/?>/i);
      var kept = rows.filter(function (row) {
        var plain = row.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
        return !LABEL_ONLY.test(plain);
      });
      if (kept.length !== rows.length) el.innerHTML = kept.join('<br>');
      var txt = el.textContent.replace(/\u00a0/g, ' ').trim();
      if (txt === '') { el.remove(); return; }
      if (/\sna\s*\.\s*$/.test(txt)) {
        el.innerHTML = el.innerHTML.replace(/\sna\s*\.\s*$/, ' preko strani <a href="/pages/contact">Kontakt</a>.');
      }
    });
    /* no phone numbers anywhere (Kenan): kill tel/WhatsApp/Viber/SMS links
       and the card table each one precedes, then any stray card that still
       mentions a phone-style channel; e-mail links point at the brand box */
    root.querySelectorAll('a[href^="mailto:"]').forEach(function (a) {
      a.setAttribute('href', 'mailto:support@vigorxs.com');
    });
    root.querySelectorAll('a[href*="wa.me"], a[href^="tel:"], a[href^="viber"], a[href^="sms:"]').forEach(function (a) {
      var card = a.nextElementSibling;
      if (card && card.tagName === 'TABLE') card.remove();
      a.remove();
    });
    root.querySelectorAll('table').forEach(function (tb) {
      if (/WhatsApp|Viber|Telefon\b/i.test(tb.textContent) && !/support@vigorxs\.com/.test(tb.textContent)) tb.remove();
    });
    /* style the 'Zadnja posodobitev' line as a chip at the top of the card */
    var ps = root.querySelectorAll('p');
    for (var i = 0; i < Math.min(ps.length, 4); i++) {
      if (/Zadnja posodobitev/i.test(ps[i].textContent)) {
        ps[i].classList.add('nf-policy-updated');
        var body = root.closest('.shopify-policy__body') || root;
        body.insertBefore(ps[i], body.firstChild);
        break;
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scrub);
  else scrub();
})();
/* ==================================================================
   NightForce — Releasit COD popup skin (Kenan):
   the popup ships styled-components classes with the pre-rebrand red
   (#BD1E1E) and no stable hooks on the upsell DODAJ buttons. Repaint
   anything still wearing the old red in brand colors, and keep the
   "Morda vam bo všeč tudi" upsell block BELOW the submit button.
   ================================================================== */
(function nfReleasitSkin() {
  var OLD_RED = 'rgb(189, 30, 30)';
  var GRAD = 'linear-gradient(110deg, #FF4A5C 0%, #C41436 35%, #1E2F7A 100%)';
  var t = null;

  function paint() {
    var form = document.querySelector('.rsi-form-main');
    if (!form) return;
    form.querySelectorAll('button, a').forEach(function (el) {
      if (el.dataset.nfSkinned) return;
      if (getComputedStyle(el).backgroundColor !== OLD_RED) return;
      el.dataset.nfSkinned = '1';
      var isSubmit = el.classList.contains('rsi-submit_button');
      el.style.setProperty('background', isSubmit ? GRAD : '#1E2F7A', 'important');
      el.style.setProperty('border', 'none', 'important');
      el.style.setProperty('border-radius', '999px', 'important');
    });
    /* upsell block below the submit button */
    var submit = form.querySelector('.rsi-submit_button');
    var label = null;
    var walker = document.createTreeWalker(form, NodeFilter.SHOW_TEXT, null, false);
    var n;
    while ((n = walker.nextNode())) {
      if (/morda vam bo v/i.test(n.nodeValue || '')) { label = n.parentElement; break; }
    }
    if (submit && label && (label.compareDocumentPosition(submit) & Node.DOCUMENT_POSITION_FOLLOWING)) {
      var common = submit.parentElement;
      while (common && !common.contains(label)) common = common.parentElement;
      if (common && common !== form.parentElement) {
        var blk = label;
        while (blk.parentElement && blk.parentElement !== common) blk = blk.parentElement;
        if (blk.parentElement === common) common.appendChild(blk);
      }
    }
  }

  function schedule() {
    clearTimeout(t);
    t = setTimeout(paint, 120);
  }

  nfIdle(function () {
    schedule();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  });
})();
/* ==================================================================
   NightForce — card hover gallery (Kenan): hovering a product card
   cycles its image through the product photos (~0.9s per photo).
   Desktop hover only; touch devices keep the static featured image.
   srcset is cleared during the cycle (it would override src) and
   restored on leave.
   ================================================================== */
(function nfCardHoverGallery() {
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
  var activeCard = null, timer = null, img = null, idx = 0, list = [];

  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
    if (img) {
      if (img.dataset.nfOrigSrc) img.src = img.dataset.nfOrigSrc;
      if (img.dataset.nfOrigSrcset) img.setAttribute('srcset', img.dataset.nfOrigSrcset);
    }
    img = null;
    activeCard = null;
  }

  function start(card) {
    var im = card.querySelector('img[data-hover-imgs]');
    if (!im) return;
    var raw = im.getAttribute('data-hover-imgs');
    if (!raw) return;
    var imgs = raw.split('|');
    if (imgs.length < 2) return;
    activeCard = card;
    img = im;
    list = imgs;
    idx = 0;
    if (!im.dataset.nfOrigSrc) {
      im.dataset.nfOrigSrc = im.getAttribute('src');
      im.dataset.nfOrigSrcset = im.getAttribute('srcset') || '';
    }
    im.setAttribute('srcset', '');
    idx = 1 % list.length;
    im.src = list[idx];
    timer = setInterval(function () {
      idx = (idx + 1) % list.length;
      img.src = list[idx];
    }, 900);
  }

  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('.fn-product-card, .fn-pg__card, .fn-bestseller-card');
    if (!card || card === activeCard) return;
    stop();
    start(card);
  });
  document.addEventListener('mouseout', function (e) {
    if (!activeCard) return;
    if (e.relatedTarget && activeCard.contains(e.relatedTarget)) return;
    if (e.target.closest && e.target.closest('.fn-product-card, .fn-pg__card, .fn-bestseller-card') === activeCard) stop();
  });
})();